import { render } from "./StagesInfo.vue?vue&type=template&id=22ce2965&scoped=true"
import script from "./StagesInfo.vue?vue&type=script&lang=js"
export * from "./StagesInfo.vue?vue&type=script&lang=js"

import "./StagesInfo.vue?vue&type=style&index=0&id=22ce2965&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ce2965"]])

export default __exports__